








































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { TagModel } from '@/type/api';
import { CreateElement, VNode } from 'vue';
import { TagStateModule, TagCategoryStateModule } from '@/store';
import Tags from './Tags.vue';

@Component<Tag>({
  components: { Tags },
})
export default class Tag extends Vue {
  // PROPS
  @Prop({ type: String, default: undefined })
  title!: string;
  @Prop({ type: Boolean, default: false })
  editable!: boolean;
  @Prop({ type: Array, default: () => [] })
  selectedTags!: TagModel.Read.Response.List[];
  /** suold be selected tags on initialize. optional. */
  @Prop({ type: Array, default: () => [] })
  specTagIDs!: string[];

  // FIELDS
  TagCategoryStateModule = TagCategoryStateModule;
  TagStateModule = TagStateModule;
  tagInput = '';
  isProcessing = false;

  // MUTATIONS
  get selectedTagsCopy(): TagModel.Read.Response.List[] {
    return this.selectedTags;
  }
  get getTagName() {
    return (tagDef: TagModel.Read.Response.List) =>
      !!tagDef && !!tagDef.tag_nm ? tagDef.tag_nm : this.$t('undefined');
  }

  // METHODS
  @Watch('specTagIDs', { immediate: true })
  onSpecTagIDsChanged(cur: string[], old: string[]) {
    (cur || []).forEach((specTagID) => {
      const finded = this.TagStateModule.allTags.find((tag) => tag.tag_id === Number(specTagID));
      if (!!finded) {
        this.selectedTags.push(finded);
      }
    });
  }
  handleClickAddTag(tag: TagModel.Read.Response.List) {
    if (this.selectedTags.map((tag) => tag.tag_id).includes(tag.tag_id)) {
      this.$snack.danger({ text: this.$t('already_added') });
      return;
    }
    this.$emit('change', tag);
  }
  async addInputTag(tagInput: string) {
    const payload = { requestBody: { tag_nm: tagInput, open_flg: 1 as 1 } };
    await TagCategoryStateModule.addTagCategory(payload).then(() => TagCategoryStateModule.readAll());
    this.tagInput = '';
  }
  handleClickDeleteTag(tag: TagModel.Read.Response.List) {
    const idx = this.selectedTagsCopy.findIndex((t) => t.tag_id === tag.tag_id);
    this.$emit('delete', idx);
  }

  // LYCYCLE HOOKS
  mounted() {
    if (this.TagCategoryStateModule.tagDefs.length === 0) {
      this.isProcessing = true;
      TagCategoryStateModule.readAll().finally(() => (this.isProcessing = false));
    }
  }
}
